import React, { useEffect, useContext } from "react";
import Utility from "../Utility";
import "../assets/styles/content_section.sass";
import { defaultRegionIndex } from "../constants";
import RegionSwitch from "../components/RegionSwitch";
import QualitySwitch from "../components/QualitySwitch";
import { PlayerContext } from "../contexts";

const Home = ({
  content,
  loading,
  channelId,
  setChannelId,
  regionIndex = defaultRegionIndex,
  setRegionIndex,
}) => {
  useEffect(() => {
    setRegionIndex(regionIndex);
  }, [regionIndex]);
  const { playReadyUrl, showPlayer, meta, playerRef, readyUrl, currentUrl } =
    useContext(PlayerContext);
  //useEffect to update the document title
  useEffect(() => {
    if (content) {
      document.title = Utility.getChannelTitle(content, channelId); // Set the document title from fetched content
    }
    setChannelId(channelId);
  }, [channelId]);
  const channel = Utility.getChannel(content, channelId);

  return (
    <div className="ur-mini-main">
      <div
        className="ur-mini-main-overlay"
        style={{
          backgroundColor:
            channel && channel.colors && channel.colors.main
              ? channel.colors.main
              : "initial",
        }}
      ></div>
      <div className="ur-mini-channel-center ur-mini-container">
        <div className="ur-mini-channel-center-row-first">
          <QualitySwitch content={content} />
          <RegionSwitch content={content} />
        </div>
        <div className="ur-mini-channel-center-row">
          <div className="ur-mini-channel-center-image-wrapper">
            <div
              className="ur-mini-channel-center-image"
              style={{
                backgroundImage:
                  channel && channel.imageUrl
                    ? `url(${channel.imageUrl})`
                    : "none",
                backgroundColor:
                  channel && channel.colors && channel.colors.main
                    ? channel.colors.main
                    : "initial",
              }}
            ></div>
            <div className="ur-mini-center-title">
              {channel && channel.title ? channel.title : null}
            </div>
            <div className="ur-mini-center-meta">
              {meta && meta.channelId == channelId && meta.title
                ? meta.title
                : null}
            </div>
          </div>
          <button
            className="ur-mini-channel-center-play-button"
            onClick={() => {
              if (
                readyUrl.url == currentUrl.url &&
                playerRef &&
                playerRef.current &&
                playerRef.current.audio
              ) {
                playerRef.current.audio.current.play();
              } else {
                showPlayer();
                playReadyUrl();
              }
            }}
          ></button>
        </div>
      </div>
    </div>
  );
};

export default Home;
